import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
//
//
//
//
//
//
import axios from "axios";
import * as Data from "./data";
import vue from "vue";
import { setTimeout } from "timers";
import Letter from "./pdfmake/Letter";
import * as Helpers from "./helpers";
export default {
  name: "App",
  data: function data() {
    return {
      loading: false,
      loadingMessage: null,
      errorMessage: null,
      warning: null,
      tokenAboutToExpireTimeout: null,
      tokenExpireTimeout: null,
      tokenAbouttoExpireTime: 1000 * 60 * 17,
      tokenExpireTime: 1000 * 60 * 20,
      count: 0
    };
  },
  created: function created() {
    var me = this;
    var config = new Data.Config(me.logOut);
    vue.$readOnly = {
      manualReadOnly: false
    };
    axios.interceptors.request.use(function (config) {
      //RESET INACTIVATION TIME
      if (Data.Authentication.TokenValid()) {
        me.setTokenExpireTimeout();
        me.setTokenAboutToExpireTimeout();
      } ///SHOW LOADING SCREEN ON ALL REQUESTS UNLESS SPECIFIED


      if (!config.doNotShowLoading) me.count++;

      if (me.count == 1) {
        me.showLoadingMessage();
      }

      return config;
    }, function (error) {
      me.count = me.count - 1;
      me.hideIfAllComplete();
      me.$q.notify({
        message: "Sorry and Error Occured. It has been logged and will be looked at",
        color: "warning"
      });
      return Promise.reject(error);
    });
    axios.interceptors.response.use(function (response) {
      if (!response.config.doNotShowLoading) {
        me.count = me.count - 1;
        me.hideIfAllComplete();
      }

      return response;
    }, function (error) {
      if ((error.request.status == 500 || error.request.status == 401) && error.request.responseURL.indexOf("/api/users/Refresh") > -1) me.count = 0;

      if (!error.config.doNotShowLoading) {
        me.count = me.count - 1;
      }

      me.hideIfAllComplete();
      return Promise.reject(error);
    });
  },
  mounted: function mounted() {},
  methods: {
    hideIfAllComplete: function hideIfAllComplete() {
      var me = this;
      setTimeout(function () {
        if (me.count <= 0) me.hideLoadingMessage();
      }, 1000);
    },
    showLoadingMessage: function showLoadingMessage(message) {
      if (!this.$q.loading.isActive) this.$q.loading.show();
    },
    hideLoadingMessage: function hideLoadingMessage() {
      this.$q.loading.hide();
    },
    showTokenExpiringMessage: function showTokenExpiringMessage() {
      var me = this; //if the user has logged out don't show

      if (!Data.Authentication.TokenValid()) return;
    },
    setTokenAboutToExpireTimeout: function setTokenAboutToExpireTimeout() {
      if (this.tokenAboutToExpireTimeout) {
        clearTimeout(this.tokenAboutToExpireTimeout);
      }

      this.tokenAboutToExpireTimeout = setTimeout(this.showTokenExpiringMessage, this.tokenAbouttoExpireTime);
    },
    setTokenExpireTimeout: function setTokenExpireTimeout() {// let me = this;
      // if (me.tokenExpireTimeout) {
      //   clearTimeout(me.tokenExpireTimeout);
      // }
      // me.tokenExpireTimeout = setTimeout(() => {
      //   // vex.close(me.warning);
      //   if (Data.Authentication.GetToken()) {
      //     Data.Authentication.LogOut();
      //     me.$router.push("/Login");
      //   }
      // }, this.tokenExpireTime);
    },
    logOut: function logOut() {
      Data.Authentication.LogOut().then(function () {
        window.location.href = "/Login";
      });
    }
  }
};